module.exports = __webpack_public_path__ + "static/media/rs.540e6996.svg";